import { render, staticRenderFns } from "./MessageTemplateItem.vue?vue&type=template&id=eac0f548"
import script from "./MessageTemplateItem.vue?vue&type=script&lang=js"
export * from "./MessageTemplateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports